import {
  LoadingIcon_default
} from "./chunk-PHTVGANV.mjs";
export {
  LoadingIcon_default as default
};
